import { render, staticRenderFns } from "./GuestsModule.vue?vue&type=template&id=727d48f8"
import script from "./GuestsModule.vue?vue&type=script&lang=js"
export * from "./GuestsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports